/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CalculationResult
 */
export interface CalculationResult {
  /**
   *
   * @type {number}
   * @memberof CalculationResult
   */
  grp: number;
  /**
   *
   * @type {number}
   * @memberof CalculationResult
   */
  budget: number;
  /**
   *
   * @type {number}
   * @memberof CalculationResult
   */
  spotsPerDayChannel: number;
  /**
   *
   * @type {number}
   * @memberof CalculationResult
   */
  spots?: number | null;
}

export function CalculationResultFromJSON(json: any): CalculationResult {
  return CalculationResultFromJSONTyped(json, false);
}

export function CalculationResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculationResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    grp: json["grp"],
    budget: json["budget"],
    spotsPerDayChannel: json["spotsPerDayChannel"],
    spots: !exists(json, "spots") ? undefined : json["spots"],
  };
}

export function CalculationResultToJSON(value?: CalculationResult | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    grp: value.grp,
    budget: value.budget,
    spotsPerDayChannel: value.spotsPerDayChannel,
    spots: value.spots,
  };
}
